import React from 'react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="relative z-10000 bg-[#0a0a0a]/90 backdrop-blur-md text-gray-300 py-16 border-t border-[#222] overflow-hidden" data-id="element-107">
      {/* Decorative light ray */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-4xl h-[1px] bg-gradient-to-r from-transparent via-[#D22B2B] to-transparent opacity-30" data-id="element-108" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-109">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12" data-id="element-110">
          <div data-id="element-111">
            <h3 className="font-noir text-2xl mb-6 text-gray-200 tracking-wide" data-id="element-112">
              KINOSOVETY
            </h3>
            <p className="text-sm text-gray-600 max-w-xs font-serif leading-relaxed" data-id="element-113">
              Цифровой архив советского киноискусства. 
            </p>
          </div>

          <div data-id="element-114">
            <h4 className="font-serif text-xs font-bold uppercase tracking-[0.2em] mb-6 text-[#D22B2B]" data-id="element-115">
              Разделы
            </h4>
            <ul className="space-y-3 text-sm text-gray-500 font-light" data-id="element-116">
              <li data-id="element-117">
                <Link to="/catalog" className="hover:text-white transition-colors duration-300" data-id="element-118">
                  Каталог фильмов
                </Link>
              </li>
              <li data-id="element-119">
                <Link to="/search" className="hover:text-white transition-colors duration-300" data-id="element-120">
                  Поиск
                </Link>
              </li>
              <li data-id="element-121">
                <Link to="/login" className="hover:text-white transition-colors duration-300" data-id="element-122">
                  Личный кабинет
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-123">
            <h4 className="font-serif text-xs font-bold uppercase tracking-[0.2em] mb-6 text-[#D22B2B]" data-id="element-124">
              Информация
            </h4>
            <ul className="space-y-3 text-sm text-gray-500 font-light" data-id="element-125">
              <li data-id="element-126">
                <Link to="/about" className="hover:text-white transition-colors duration-300" data-id="element-127">
                  О проекте
                </Link>
              </li>
              <li data-id="element-128">
                <Link to="/contact" className="hover:text-white transition-colors duration-300" data-id="element-129">
                  Контакты
                </Link>
              </li>
              <li data-id="element-130">
                <Link to="/rights" className="hover:text-white transition-colors duration-300" data-id="element-131">
                  Правообладателям
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-[#1a1a1a] flex flex-col md:flex-row justify-between items-center gap-4 text-[10px] uppercase tracking-widest text-gray-700" data-id="element-132">
          <p data-id="element-133">© 2024 Kinosovety.ru. Noir Edition.</p>
          <p data-id="element-134">Описания из официальных каталогов</p>
        </div>
      </div>
    </footer>;
}